import styles from "./Footer.module.css";

const Footer = () => {
    return (
        <footer className={styles.footer}>
            <p>© 2026 TravelBuddy. All rights reserved.</p>
        </footer>
    );
};

export default Footer;